import {BasePage} from "@reapptor-apps/reapptor-react-common";
import ApplicationSettings from "@/models/server/ApplicationSettings";
import {TBasePageParameters} from "@reapptor-apps/reapptor-react-common/src/base/BasePage";
import ApplicationContext from "@/models/server/ApplicationContext";

export default abstract class AnonymousPage<TProps extends TBasePageParameters = {}, TState = {}>
    extends BasePage<TProps, TState, ApplicationContext> {
    
    public get settings(): ApplicationSettings {
        return this.getContext().settings;
    }
}